import './App.css';
import {Route, BrowserRouter, Routes } from "react-router-dom";
import CookiesDialog from './cookiesdialog/CookiesDialog'
import HeaderForm from './header/Form'
import FooterForm from './footer/Form'
import TripList from './trip/List'
import TripForm from './trip/Form'
import BookingForm from './booking/Form'
import React, {useState} from "react";
import {addLocale} from "primereact/api";
import UeberunsForm from './uberuns/Form'
import FaqForm from './faq/Form'
import ImpressumForm from './impressum/Form'
import DatenschutzForm from './datenschutz/Form'
import AgbForm from './agb/Form'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import backgroundImg from './background.png'
import {ProgressSpinner} from "primereact/progressspinner";


ModuleRegistry.registerModules([AllCommunityModule]);

export const UserContext = React.createContext(null);

function App() {

    const isXL = window.innerWidth >= 1200;

    const [progress, setProgress] = useState(true);

    const [searchSwitch, setSearchSwitch] = useState("searchPanel")
    const [trips, setTrips] = useState([]);
    const [selectedFavorite, setSelectedFavorite] = useState(false);
    const [selectedState, setSelectedState] = useState({code: null, name: 'Alle'});
    const [selectedLanguage, setSelectedLanguage] = useState({code: null, name: 'Alle'});
    const [selectedSuitableFor, setSelectedSuitableFor] = useState();
    const [selectedAppointmentLength, setSelectedAppointmentLength] = useState({code: null, name: 'Beliebig'});
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedAppointment, setSelectedAppointment] = useState();

    addLocale('de', {
        firstDayOfWeek: 1,
        dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        monthNamesShort: ['Jan', 'Geb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Drp', 'Okt', 'Nov', 'Dez'],
        today: 'Heute',
        clear: 'Leer'
    });
  return (
    <div className="App">

        <CookiesDialog/>
        <img style={{position: 'fixed', width: '100%'}} src={backgroundImg}/>

        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}>

            <BrowserRouter>
                <HeaderForm
                    setProgress={(progress) => setProgress(progress)}
                    trips={trips}
                    isXL={isXL}
                    setTrips={(trips) => setTrips(trips)}
                    searchSwitch={searchSwitch}
                    setSearchSwitch={(searchSwitch) => setSearchSwitch(searchSwitch)}
                    selectedFavorite={selectedFavorite}
                    setSelectedFavorite={(selectedFavorite) => setSelectedFavorite(selectedFavorite)}
                    selectedState={selectedState}
                    setSelectedState={(selectedState) => setSelectedState(selectedState)}
                    selectedLanguage={selectedLanguage}
                    setSelectedLanguage={(selectedLanguage) => setSelectedLanguage(selectedLanguage)}
                    selectedSuitableFor={selectedSuitableFor}
                    setSelectedSuitableFor={(selectedSuitableFor) => setSelectedSuitableFor(selectedSuitableFor)}
                    selectedAppointmentLength={selectedAppointmentLength}
                    setSelectedAppointmentLength={(selectedAppointmentLength) => setSelectedAppointmentLength(selectedAppointmentLength)}
                    selectedLocation={selectedLocation}
                    setSelectedLocation={(selectedLocation) => setSelectedLocation(selectedLocation)}
                    selectedAppointment={selectedAppointment}
                    setSelectedAppointment={(selectedAppointment) => setSelectedAppointment(selectedAppointment)}/>

                <Routes>
                    <Route path="/" element={
                        <React.Fragment>

                            {progress && (
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 400px)', width: '100%'}}>

                                    <ProgressSpinner />
                                </div>
                            )}

                            {!progress && (
                                <TripList
                                    trips={trips}
                                    setTrips={(trips) => setTrips(trips)}
                                    selectedAppointment={selectedAppointment}
                                    setSelectedAppointment={(selectedAppointment) => setSelectedAppointment(selectedAppointment)}/>
                            )}
                        </React.Fragment>
                    }/>

                    <Route path="/ueberuns" element={
                        <UeberunsForm/>
                    }/>
                    <Route path="/faq" element={
                        <FaqForm/>
                    }/>
                    <Route path="/trip" element={
                        <TripForm/>
                    }/>
                    <Route path="/bookings/" element={
                        <BookingForm/>
                    }/>
                    <Route path="/datenschutz" element={
                        <DatenschutzForm/>
                    }/>
                    <Route path="/impressum" element={
                        <ImpressumForm/>
                    }/>
                    <Route path="/agb" element={
                        <AgbForm/>
                    }/>
                </Routes>

                <FooterForm/>

            </BrowserRouter>
        </div>


    </div>
  );
}

export default App;
